import { isEmpty, noop } from 'lodash'
import * as Yup from 'yup'
import { HORIZONTAL, VERTICAL } from './constant'

export const SingleTextSchema = Yup.object().shape({
  headerTitle: Yup.string(),
  onClick: Yup.mixed(),
  isInteractive: Yup.bool().default(false),
  data: Yup.object()
    .shape({
      title: Yup.string().required(),
      value: Yup.string().required()
    })
    .required()
})

export const InlineTextSchema = Yup.object().shape({
  headerTitle: Yup.string(),
  data: Yup.array().of(
    Yup.object().shape({
      title: Yup.string().required(),
      value: Yup.string().required()
    })
  )
})

export const PipeTextSchema = Yup.object().shape({
  headerTitle: Yup.string(),
  onClick: Yup.mixed(),
  data: Yup.array().of(
    Yup.object().shape({
      title: Yup.string().required(),
      value: Yup.string().required()
    })
  ),
  config: Yup.object().shape({
    pipe: Yup.bool().default(true),
    isInteractive: Yup.bool().default(false),
    direction: Yup.string().oneOf([HORIZONTAL, VERTICAL]).default(HORIZONTAL)
  })
})

export const TableSchema = Yup.object().shape({
  headerTitle: Yup.string(),
  data: Yup.array().of(Yup.object()),
  config: Yup.object()
    .shape({
      exportBtn: Yup.boolean(),
      columnsDef: Yup.array()
        .of(
          Yup.object().shape({
            key: Yup.string(),
            header: Yup.string()
          })
        )
        .required()
    })
    .required()
})

export const ButtonsListSchema = Yup.object().shape({
  headerTitle: Yup.string(),
  submit: Yup.object().shape({
    title: Yup.string().required(),
    onClick: Yup.mixed()
  }),
  actionBtn: Yup.boolean(),
  data: Yup.array()
    .of(
      Yup.object().shape({
        title: Yup.string().required(),
        onClick: Yup.mixed(),
        selected: Yup.boolean(),
        color: Yup.string()
      })
    )
    .required()
})

export const CustomSchema = {
  validateSync: ({ children }) => {
    if (isEmpty(children)) {
      throw new Error('ValidationError: children is a required field')
    }
  }
}

export const validateSchema = (Schema = { validateSync: noop }, body) => {
  try {
    Schema.validateSync(body)
    return null
  } catch (error) {
    return error
  }
}
